export default {
  playedPiecesTitle: 'Performed pieces:',
  loading: 'Loading...',
  success: 'Success',
  failed: 'Failed',
  emptyHistory: 'No performance records',
  emptyPerformLog: 'No performance log or video',
  performVideoLabel: 'Performance Video',
  liveStreamVideoLabel: 'Piano Robot Live Stream',
  back: 'Back',

  performMode: 'Performance Mode',
  voiceInput: 'Voice input',
  stopPerform: 'Stop performance',
  fetchSongs: 'Song List',
  startService: 'Start Service',
  emptyHello: 'Hello!',
  emptySub: 'Tell me which piece you would like to hear',
  thinkingProcess: 'Thinking:',
  planningLabel: 'Planning',
  songListTitle: 'Song List',
  closeSongList: 'Close song list',
  songListFetchError: 'Failed to load song list',
  noSongs: 'No songs available',
  loadMoreSongs: 'Load more songs',
  serviceStarted: 'Piano robot service started',
  playSongPrompt: 'Please play {name}',
  uplinkSpeedTitle: '5G-A Uplink Speed',
  uplinkLatencyTitle: '5G-A Uplink Latency',
  poweredBy: 'Powered by TermiTech',

  planStep: {
    searchSong: 'Search song',
    analyzeSong: 'Analyze song',
    parseHardware: 'Parse hardware parameters',
    generateFingering: 'Generate fingering from hardware',
    startPlaying: 'Start playing',
  },

  hardwareStepDesc:
    'Arms: 7-DOF Rokae AR5 ×2; hands: 18-DOF TermiHand tendon-driven dexterous hands.\nAnalysis: arm motion latency exceeds 0.3s; pinky may be mapped to one additional key.',
}
